<template>
    <div class="header">
        <div class="head__top frame-padding">
            <div>
                <a href="https://vk.com/vk_stomat51?ysclid=mhxloa1gd6303514223" target="_blank">
                    <svg width="27" height="17" viewBox="0 0 27 17" fill="none"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.7499 6.68633V2.06637C15.7499 1.02512 15.5611 0.816376 14.5249 0.816376L11.5874 0.750126C10.6724 0.750126 10.2149 0.750126 10.0299 1.04637C9.84492 1.34262 10.0499 1.74887 10.4587 2.55886C10.6862 3.00886 10.8087 3.3351 10.8087 3.8401V7.16507C10.8087 8.21506 10.8087 8.74131 10.4087 8.89756C10.0087 9.05256 9.67743 8.70006 9.01243 7.99506C7.38744 6.26508 6.53994 4.1051 5.9837 1.75012C5.8687 1.26262 5.8112 1.01887 5.6387 0.883875C5.4662 0.748876 5.21995 0.750126 4.72996 0.750126H1.97997C1.37748 0.750126 1.07623 0.750126 0.887478 0.962625C0.699979 1.17637 0.736229 1.44887 0.808728 1.99262C1.46872 6.90132 5.78495 14.95 13.7587 15.7175C15.1711 15.8525 15.7499 15.4713 15.7499 13.9238C15.7499 13.0463 15.7311 11.6288 16.8349 11.4425C17.4136 11.345 17.8024 11.5513 18.4486 12.0925C19.5686 13.0325 20.1561 14.18 20.5649 15.0513C20.8361 15.6288 21.0374 15.75 21.6749 15.75H24.2673C25.5773 15.75 25.9336 15.43 25.3498 14.2C24.6901 12.8206 23.7561 11.5901 22.6048 10.5838C21.8099 9.90005 21.4136 9.5588 21.3924 9.3063C21.3686 9.05506 21.6599 8.69881 22.2424 7.98632C23.3673 6.60883 24.8998 4.4476 25.6148 2.15386C25.9698 1.01637 25.6361 0.750126 24.4848 0.750126H22.1561C21.0274 0.750126 21.0286 0.711377 20.7624 1.99137C20.3299 4.0676 18.9149 6.06383 17.5849 7.42257C16.9536 8.06757 16.5724 8.45631 16.1786 8.29756C15.7849 8.13881 15.7499 7.65632 15.7499 6.68633Z" />
                    </svg>
                </a>
                <h1>
                    МОСП «Мурманская областная стоматологическая поликлиника»
                </h1>
                <button @click="()=>{this.showSightless=!this.showSightless; this.$emit('sightless',this.showSightless)}"> 
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6064 5.08101C19.114 4.86362 19.7014 5.09882 19.9189 5.6064L22.7568 12.2285C22.917 12.6019 22.9999 13.0047 23 13.4111V14L22.9932 14.2568C22.8594 16.8988 20.6753 19 18 19C15.4621 19 13.3667 17.1089 13.0439 14.6591C12.7107 14.5355 12.3572 14.4716 12 14.4716C11.6425 14.4716 11.2886 14.5353 10.9551 14.6591C10.6323 17.1089 8.53787 19 6 19C3.32474 19 1.14055 16.8988 1.00684 14.2568L1 14V13.4091L1.00391 13.2568C1.02217 12.9031 1.10321 12.5547 1.24316 12.2285L4.08105 5.6064C4.29856 5.09882 4.88596 4.86362 5.39355 5.08101C5.90112 5.29852 6.13633 5.88591 5.91895 6.39351L4.73242 9.16206C5.13724 9.05629 5.56203 8.99995 6 8.99995C8.28157 8.99995 10.2047 10.5285 10.8047 12.6171C11.1946 12.5211 11.5958 12.4716 12 12.4716L12.29 12.4804C12.5956 12.4982 12.8982 12.5443 13.1943 12.6171C13.7943 10.5284 15.7183 8.99995 18 8.99995C18.4376 8.99995 18.8621 9.05644 19.2666 9.16206L18.0811 6.39351C17.8637 5.88591 18.0989 5.29852 18.6064 5.08101ZM6 11C4.34315 11 3 12.3431 3 14C3.00003 15.6568 4.34316 17 6 17C7.65684 17 8.99997 15.6568 9 14C9 12.3431 7.65685 11 6 11ZM18 11C16.3431 11 15 12.3431 15 14C15 15.6568 16.3432 17 18 17C19.6568 17 21 15.6568 21 14C21 12.3431 19.6569 11 18 11Z" />
                    </svg>
                    Версия для слабовидящих
                </button>
            </div>
        </div>
        <div>
        <search-ms  :show="!showMenu"  :adress="mailAdress" :show-record="showRecord"></search-ms>
        </div>
        <menu-head-ms :items="items" @active="(e)=>{this.showMenu = e; this.$emit('active',e)}" @show-record="()=>{this.showRecord = !this.showRecord}">
        </menu-head-ms>
    </div>
</template>
<script>
import search from './header/SearchMs.vue'
import menuHead from './header/MenuHeadMs.vue'

import axios from 'axios'
export default{
    components:{
        SearchMs: search,
        MenuHeadMs:menuHead,
    },
    watch:{
        isShowRecord(){
            this.showRecord = !this.showRecord;
        }
    },
    mounted(){
        axios
            .get('https://mosp51.ru/api/offices/adress?main')
            .then(response=>{
                this.mailAdress = response.data.adress           
            })
        axios
            .get('https://mosp51.ru/api/menu')
            .then(response=>{
                this.items = response.data
            })

    },
    props:['isShowRecord'],
    data(){
        return{
            mailAdress:'',
            items:[
            ],
            showMenu:false,
            showRecord:false,
            showSightless:false,
            
        }
    }
}
</script>
<style>
    .header{
        box-shadow:0 0 40px 0 #EEEEEE66, 0 5px 5px 0 #E5EDF5;
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 3;
        background-color: var(--white);
    }
    .header .head__top{
        background-color: #EDF6FF;
    }
    .header .head__top>div{
        color: #175472;
        display:flex;
        justify-content: space-between;
        align-items: center;
        height: 45px;
    }
    .head__top a{
        height: 17px;
        stroke:#175472;
    }
    .head__top h1{
        font-weight: 501;
        font-size: 18px;
        margin: 0;
    }
    .head__top button{
        font-weight: 501;
        display:flex;
        align-items: center;
        gap:16px;
        font-family: Rubik,sans-serif;
        font-size: 16px;
        color: #175472;
        fill: #175472;
        background-color: transparent;
        border: none;
        margin: 0;
        cursor: pointer;
    }
    .head__top button:hover{
        color:#007BB8;
        fill: #007BB8;
    }
    .head__top a:hover{
        stroke:#007BB8;
    }
     @media (max-width: 1000px){
        .header{
            box-shadow: none;
        }
        .header .head__top{
            font-size: 10px;
            display: block;
        }
        .header .head__top h1{
            font-size: 10px;
        }
        .header .head__top > div{
            height: 21px;
        }
        .ms__logo img{
            height:23px;
        }
        .header__menu{
            height: 0px;
        }

        .header__menu button{
            position: absolute;
            top: 32px;
            width: 20px;
            height: 14px;
        }
        .header__menu button::before,
        .header__menu button::after{
            height: 2px;
        }
        .header__menu > button::after{
            box-shadow: 0px 6px #175472;
        }
        
    }
</style>

